import { render, staticRenderFns } from "./mall.vue?vue&type=template&id=56245b0a&scoped=true"
import script from "./mall.vue?vue&type=script&lang=ts"
export * from "./mall.vue?vue&type=script&lang=ts"
import style0 from "./mall.vue?vue&type=style&index=0&id=56245b0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56245b0a",
  null
  
)

export default component.exports